<template>
  <div>
    <v-container grid-list-xs style="height: 80%;">
       <v-row>
        <v-col cols="12" md="4">
          <v-text-field prepend-inner-icon="search" v-model="search" label="Search..."></v-text-field>
        </v-col>
       </v-row>
    </v-container>
    <v-data-table
      v-if="clients && regions"
      :headers="headers"
      :search="search"
      :items="renderedManifests"
    >
      <template v-slot:item="props">
        <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}">
          <td style="text-align: center"
              @click="selectClient(props.item, clients.filter((client) => {return props.item.client_id === client.id})[0])">
            {{props.item.id}}
          </td>
          <td style="text-align: center"
              @click="selectClient(props.item, clients.filter((client) => {return props.item.client_id === client.id})[0])">
            {{props.item.client_name}}
          </td>
          <td style="text-align: center"
              @click="selectClient(props.item, clients.filter((client) => {return props.item.client_id === client.id})[0])">
            {{props.item.region_name}}
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  import axios from 'axios'

  // @vuese
  // Manifests table
  // @group Manage Manifests
  export default {
    name: "ClientTable",
    props: {
      // @vuese Function triggered when a manifest has been clicked on
      selectClient: Function,
      // @vuese manifests array of Objects
      manifests: Array,
    },
    data() {
      return {
        search: null,
        headers: [
          {text: 'ID', value: 'id', align: 'center'},
          {text: 'Client', value: 'client_name', align: 'center'},
          {text: 'Region', value: 'region_name', align: 'center'},
          // {text: 'Product type', value: 'product_type', align: 'center'},
        ],
      }
    },
    computed: {
      regions() {
        let regions = this.$store.state.auth.regions;
        regions.unshift({id: 0, name: 'Global'});
        return regions;
      },
      // @vuese
      // Manifest array of Objects that is to be displayed in the table.
      renderedManifests() {
        let output = [];
        output = this.manifests.map((manifest) => {
          manifest.client_name = this.clients.filter((client) => {
            return manifest.client_id === client.id
          })[0].name;
          return manifest
        });

        output = this.manifests.map((manifest) => {
          manifest.region_name = this.regions.filter((region) => {
            return manifest.region_id === region.id
          })[0].name;
          return manifest
        });
        return output
      },
      // renderedClient() {
      //   let output = [];
      //   output = this.clients.filter((client) => {
      //     return client.active === true || this.inactiveSwitch
      //   });
      //   return output
      // }
    },
    asyncComputed: {
      async clients() {
        return await axios.get(process.env.API_URL + '/clients?inactive=true')
          .then((response) => {
            return response.data;
          })
          .catch((response) => {
            return [];
          })
      },
    }
  }
</script>

<style scoped>

  >>>.v-tabs-bar.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows):not(.v-slide-group--has-affixes) .v-slide-group__prev {
    display: none!important;
  }

</style>



// WEBPACK FOOTER //
// src/components/util/ManageManifests/ManifestsTable.vue